import axios from "axios";
import { cbanklocal } from "../app.config";
import store from "../store/store";
// import store from "@/store/store";

const apiClient = axios.create({
      baseURL: cbanklocal,
      withCredentials: false,
      headers: {
        Accept: "application/json",
            "ContentType": "application/json"
      }
});

const apiClient2 = axios.create({
      baseURL: cbanklocal,
      withCredentials: false,
      headers: {
        Accept: "application/json",
            "ContentType": "application/json"
      }
});

apiClient2.interceptors.request.use(config => {
    store.getters["auth/getUserTokenFromLocalStorage"] != null ? config.headers.Authorization = store.getters["auth/getUserTokenFromLocalStorage"] : '';
    return config;
});
// https://corsanywhere.herokuapp.com



export default {
  callLogonApi(payload) {
        // console.log("Service Payload ==>>", payload)
            return apiClient.post("auth/login", payload);
      },
    callUserDetails(payload) {
        // console.log("Service Payload ==>>", payload)
            return apiClient2.post("auth/details", payload);
      },
    resetPassword(payload){
        // console.log("Service Payload ==>>", payload)
        return apiClient.post("auth/resetpassword", payload);
    },
    forgotPassword(payload){
        // console.log("Service Payload ==>>", payload)
        return apiClient.post("auth/forgotpassword", payload);
    }


};
